import React from 'react'
import { FormattedMessage } from 'react-intl'

export const LANDING_TOURS_OF_DUTY_HEADER = (
    <FormattedMessage
        id='landing_tours_of_duty.header'
        defaultMessage='Боевые походы'
    />
)

export const LANDING_TOURS_OF_DUTY_MESSAGE1 = (
    <FormattedMessage
        id='landing_tours_of_duty_header.message1'
        // eslint-disable-next-line max-len
        defaultMessage={'Когда вы вступите в клан, вам станут доступны регулярные игровые события{nbsp}— Боевые походы.'}
        values={{
            nbsp: <span>&nbsp;</span>,
        }}
    />
)

export const LANDING_TOURS_OF_DUTY_MESSAGE2 = (
    <FormattedMessage
        id='landing_tours_of_duty_header_message2'
        // eslint-disable-next-line max-len
        defaultMessage={'Играя в своём обычном режиме, вы сможете выполнять специальные задачи, продвигаться в Боевом походе, получать ценные награды, а также помогать в этом всем игрокам клана.'}
    />
)


// WEBPACK FOOTER //
// ./containers/Landing/components/LandingToursOfDuty/translations.jsx